import { makeStyles } from "@material-ui/core";

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

export const useBaseStyles = makeStyles(
  (theme) => ({
    label: {
      display: "block",
      color: (props: any) =>
        props.error ? theme.palette.error.main : theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: 13,
      padding: 0,
      textAlign: "left",
      cursor: "pointer",
    },
  }),
  { name: "input-field-base-style", flip: null }
);

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      transition: theme.transitions.create([
        "border-color",
        "box-shadow",
        "background-color",
      ]),
      "&:hover": {
        backgroundColor: "#fcfcfb",
      },
      "&$focused": {
        backgroundColor: theme.palette.common.white,
      },
      "&$disabled": {
        backgroundColor: "#fcfcfb",
        "& .MuiInputAdornment-root": {
          opacity: 0.6,
        },
      },
      "&$disabled $notchedOutline": {
        border: `1px solid ${defaultBorder(theme)}`,
      },
      "&$focused $notchedOutline": {
        border: `1px solid ${defaultBorder(theme)}`,
      },
      "&$error": {
        backgroundColor: theme.palette.common.white,

        "&:hover $notchedOutline": {
          border: `1px solid ${theme.palette.error.main}`,
        },

        "& .MuiInputAdornment-root": {
          color: theme.palette.error.main,
        },

        "& input": {
          color: theme.palette.error.main,
        },
      },

      "& $notchedOutline": {
        border: `1px solid ${defaultBorder(theme)}`,
        borderRadius: 2,
      },
      "&:hover $notchedOutline": {
        border: `1px solid ${defaultBorder(theme)}`,
      },
      "& .MuiInputAdornment-root": {
        color: theme.palette.text.primary,
        opacity: 0.8,

        "& svg": {
          height: "1.1rem",
          width: "1.1rem",
        },
      },
    },
    input: {
      paddingTop: 11,
      paddingBottom: 14,
      fontSize: 14,
    },
    error: {},
    focused: {},
    disabled: {},
    notchedOutline: {},
  }),
  { name: "input-field-style", flip: null }
);

export const useHelperTextStyles = makeStyles(
  (theme) => ({
    root: {
      color: "red",
      fontSize: 14,
      margin: "4px 2px",
    },
  }),
  {}
);
